export * from './src/camera-scan.component';
export * from './src/camera-scan-dialog.service';
